const state = {
  topServiceCategoryGroup: {},
  selectedServices: [],
  maintenancePositions: []
};

export default state;
